<template>
  <div class="w-full max-w-7xl mx-auto px-[4vw] pb-12">
    <Head>
      <Title>{{ $t('events.city.meta.title', { prefixedCity }) }}</Title>
      <Meta name="description" :content="$t('events.city.meta.description', { prefixedCity })" />
    </Head>
    <AtomPageHeader class="mt-2 lg:mt-8"
      :heading="!!event ? heading : $t('events.city.heading', { prefixedCity })"
      :leading="$t('events.city.leading', { prefixedCity })"
    />
    <EventsNav class="_sticky z-30 top-14 py-4 px-4 -mx-4 bg-white" />
    <EventsList />
  </div>
</template>

<script async setup>
const route = useRoute()
const fat = useFatStore()

const prefixedCity = usePrefixedCityName(fat.city?.name)

// Get start and end date
const startDate = computed(() => route.query?.startDate || route.query?.date)
const endDate = computed(() => route.query?.endDate || startDate.value)

// Get heading by tag
const event = computed(() => useEventByDate(startDate.value, endDate.value))
const heading = computed(() => event.value?.name + ', ' + fat.city?.name)

// Show 404 if city slug is undefined 
if (!useCityBySlug(route.params?.city)) {
  throw createError({
    statusCode: 404,
    message: 'not found',
    fatal: true
  })
}
</script>